import React, {useEffect, useState} from 'react';
import './App.scss';
import {useTranslation} from 'react-i18next';
import {Link, Route, Routes, useLocation, useNavigate,} from "react-router-dom";
import Promotional from './components/pages/promotional/Index'

// import { Button } from 'react-bootstrap';
import Flag from './Flag';

import {PromotionChild} from './components/pages/new-promo-inside/PromotionChild';
import Logo from './components/pages/promotional/images/OGLogo-transparent.png';
import {DEFAULT_LANGUAGE, getFlagByLanguageCode, getLanguageCodeFromUrl} from "./helper/language";

function App() {

  const location = useLocation();
  const navigate = useNavigate();
  // const { i18n } = useTranslation();

  const { t, i18n } = useTranslation();
  const websitePromo = t('WEBSITE_PROMO', { returnObjects: true });
  const [modalShow, setModalShow] = useState(false);
  const [flag, setFlag] = useState(getFlagByLanguageCode(DEFAULT_LANGUAGE));
  
  useEffect(() => {
    const languageCode = getLanguageCodeFromUrl(window.location.href);
    i18n.changeLanguage(languageCode)
  }, [i18n])

  useEffect(() => {
    if (location.pathname === '/') {
      navigate("/promotional");
    }
  }, [location, navigate])

  useEffect(() => {
    setFlag(getFlagByLanguageCode(i18n.language));
  }, [i18n, i18n.language]);

  return (
    <div className="App">
      <div className="main-logo">
        <Flag show={modalShow} onHide={() => setModalShow(false)} className={`${location.pathname.substr(1,)}-css`} />
        <Link to={`/promotional?lang=${i18n.language}`}>
          <img src={Logo} alt="Orientalal Game" />
          <div className='promotion-text'><span>{websitePromo.PROMOTIONS}</span></div>
        </Link>
        <div className='logo-flag'>
          <img onClick={() => setModalShow(true)} className={`${location.pathname.substr(1,)}`} src={flag} alt="Flag" />
        </div>
      </div>
      <Routes>
        <Route path="/promotional" element={<Promotional />} />
        <Route path="/promotional/:id" element={<PromotionChild />} />
      </Routes>

    </div>
  );
}

export default App;
